import { useViewerMaybe } from "@/authentication/ViewerProvider"
import { rootPath as employeePortalPath } from "@/novus/novus-paths"
import { rootPath as employerPortalPath } from "@/org-admins/org-admins-paths"
import { useLogout } from "@/util/useLogout"
import React from "react"
import { Link } from "react-router-dom"

export const Footer = () => {
  const logout = useLogout()
  const { viewer } = useViewerMaybe()
  return (
    <footer className="bg-black text-white px-2 md:px-16 text-[9pt] leading-[24px]">
      <div className="container w-full">
        <div className="flex flex-row py-12 px-0 justify-content-between">
          <div className="mr-auto mb-4">
            <img
              width="40"
              alt="Hadley Logo"
              src="/assets/hadley-logo-white-bcc69c022cc6745d6f0bc0a66b97fdf438bdf4a727408fd856fa2fb7d3f15950.svg"
            />
            <div className="mt-4">
              <a title="LinkedIn" href={window.novus.linkedInUrl}>
                <span className="inline-flex items-center rounded-full bg-purple px-2 py-2 w-30 h-30">
                  <img
                    height="10"
                    alt="LinkedIn Logo"
                    src="/assets/marketing/linkedin-25b9037fe1958736b3eee7934f9cfc3545910b8cdef74b1e31e10b5be090c5a6.svg"
                  />
                </span>
              </a>
            </div>
          </div>
          <div className="max-w-36 px-2">
            <ul className="list-unstyled">
              <li>
                <a className="active" href="/">
                  Home
                </a>
              </li>
              <li>
                <a className="" href="/find-a-plan">
                  Find My 529
                </a>
              </li>
              <li>
                <a className="" href="/our-story">
                  Our Story
                </a>
              </li>
              <li>
                <a className="" href="/find-a-plan/explained">
                  Questionnaire Explained
                </a>
              </li>
              <li>
                <a href="/#download">Download the App</a>
              </li>
            </ul>
          </div>
          <div className="max-w-[160px] px-2">
            <ul className="list-unstyled">
              <li>
                <a className="" href="/faq">
                  FAQ
                </a>
              </li>
              <li>
                <a href="/#contact">Contact</a>
              </li>
              <li>
                <a className="" href="/legal">
                  Legal Disclaimer
                </a>
              </li>
              <li>
                <a href={employerPortalPath({})}>Employer Admin</a>
              </li>
              <li>
                <a href={employeePortalPath({})}>Employee Portal</a>
              </li>
              <li>
                {!!viewer && (
                  <button
                    onClick={() => {
                      logout()
                    }}
                  >
                    Log Out
                  </button>
                )}
              </li>
            </ul>
          </div>
        </div>
        <div className="pb-2" style={{ fontSize: "9pt" }}>
          © Copyright 2026 Hadley Investment Co. All Rights Reserved
        </div>
      </div>
    </footer>
  )
}
